import React from 'react'
import * as H from 'history'
import { Alert } from 'react-bootstrap'
import { ISupportSpinner } from '../../../shared/Ajax'
import { ApplicationController } from '../../../controllers/ApplicationController'
import { ApplicationModel } from '../../../models/ApplicationModel'
import Tier from './Components/Tiers/index'
import RepresentativeAgreement from './Components/RepresentativeAgreement'
import { NextBackButtons } from '../../applicationForm-1/controls/NextBackButtons'
import { TabHeading, validateFields } from '../../../shared/fields'
import { getInvalidFileBlobIds } from '../../../shared/Utility'
import { Backdrop } from '../../../shared/Backdrop'
import tierActiveValidator from '../../../shared/tierActiveValidator'
import { DashboardFetch } from '../../../controllers/DashboardFetch'
import { HomeFetch } from '../../../controllers/HomeFetch'

export interface EligibleTiersPageProps {
    history: H.History
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    markets: any[]
    marketRegions: string[]
    preview?: boolean
}

export interface EligibleTiersPageState {
    loading: boolean
    dialog: boolean
    tierSelectionIsValid: boolean // includes RepBody;
    tierErrorMessage: string
}

export class EligibleTiersPage extends React.Component<EligibleTiersPageProps, EligibleTiersPageState> implements ISupportSpinner {
  ajax: ApplicationController
  tiers: Tier
  representativeAgreement: RepresentativeAgreement
  dashboardFetch: DashboardFetch
  homeFetch: HomeFetch

  constructor(props: EligibleTiersPageProps) {
    super(props)

    this.ajax = new ApplicationController()
    this.dashboardFetch = new DashboardFetch()
    this.homeFetch = new HomeFetch()

    this.state = {
      loading: false,
      dialog: false,
      tierSelectionIsValid: true, // if you get to this Tab, it must be true (until you re-validate it)
      tierErrorMessage: '',
    }
  }

  next = () => {
    const { loading } = this.state

    if (loading) {
      return
    }

    validateFields(
      (res) => {
        if (res) {
          const { model, history, onChange } = this.props

          const invalidDocuments = getInvalidFileBlobIds(model)
          const updatedModel = { ...JSON.parse(JSON.stringify(model)), invalidDocuments }

          this.ajax.updateApplication(
            this,
            updatedModel,
            (d) => {
              onChange({ ...model, ...d })
              this.setState({ tierSelectionIsValid: false }, async () => {
                await this.validateTierOnSaveNext()

                // Only navigate to next page if validation passes
                // eslint-disable-next-line react/destructuring-assignment
                if (this.state.tierSelectionIsValid) {
                  history.push(`/reform/${model.applicationID}/expenses`)
                }
              })
            },
          )
        }
      },
      this.tiers,
      this.representativeAgreement,
    )
  }

  validateTierOnSaveNext = async (): Promise<void> => {
    const { model } = this.props
    const selectedTierValue = model.isPeakIndustryBody ? '0' : model.applicationTier // for RepBody, LHS = 0;

    await tierActiveValidator({
      selectedTierValue,
      dashboardFetch: this.dashboardFetch,
      setState: this.setState.bind(this),
    })
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  render() {
    const {
      onChange, model, history, markets, marketRegions, preview,
    } = this.props

    const { loading, tierErrorMessage } = this.state

    return (
      <>
        <TabHeading
          label="Eligible tiers"
          preview={preview}
        />
        { model.isPeakIndustryBody === false && <Tier model={model} onChange={onChange} ref={(r) => { this.tiers = r }} markets={markets} marketRegions={marketRegions} preview={preview} /> }
        { model.isPeakIndustryBody && <RepresentativeAgreement model={model} onChange={onChange} ref={(r) => { this.representativeAgreement = r }} preview={preview} /> }
        <NextBackButtons
          onBack={() => history.push(`/reform/${model.applicationID}/applicant`)}
          onNext={this.next}
          preview={preview}
        />
        {/* tierValidation on SaveNext; user-story #143098 */}
        {tierErrorMessage
            && (
            <Alert className="emdg-page-alerts emdg-page-alerts--error">
              <div dangerouslySetInnerHTML={{ __html: tierErrorMessage }} />
            </Alert>
            )}
        <Backdrop on={loading} />
      </>
    )
  }
}
